/* Auto-generated from test-schemas.proto */
export interface IBazBar {
    baz?: string;
    bar?: string;
}
export enum JobState {
    Submitted = 0,
    Pending = 1,
    Running = 2,
    Completed = 3,
    Failed = 4,
    Aborted = 5
}
export interface IJobResult {
    state?: JobState;
    result?: number;
}
